export const notEmptyRule = (t, message) => ({
  validator: (_, value) => {
    if (!value || value.trim() === '') {
      return Promise.reject(new Error(message || 'Il campo non può essere vuoto'));
    }
    return Promise.resolve();
  }
});

export const optionalNotWhitespaceRule = (t, message) => ({
  validator: (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    if (value.trim() === '') {
      return Promise.reject(new Error(message || 'Il campo non può contenere solo spazi vuoti'));
    }
    return Promise.resolve();
  }
}); 